"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Subtitle2Stronger: function() {
        return _Subtitle2Stronger.Subtitle2Stronger;
    },
    subtitle2StrongerClassNames: function() {
        return _useSubtitle2Strongerstyles.subtitle2StrongerClassNames;
    }
});
const _Subtitle2Stronger = require("./Subtitle2Stronger");
const _useSubtitle2Strongerstyles = require("./useSubtitle2Stronger.styles");
